import { Body, Controller, Post } from "@nestjs/common";
import { ApiBody, ApiTags } from "@nestjs/swagger";
import { ApplicationExceptionHandler } from "@project-management-system/backend-utils";
import {  CommonResponseModel } from "@project-management-system/shared-models";
import { PlantsDto } from "./plants.dto";
import { PlantsService } from "./plants.service";
import { PlantIdReq } from "./plant-id.req";


@Controller('plants')
@ApiTags('/plants')
export class PlantsController {
    constructor(private service: PlantsService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler
    ) { }

    @Post('/getAllPlants')
    async getAllPlants(): Promise<CommonResponseModel> {
        try {
            return await this.service.getAllPlants();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }

    @Post('/createPlant')
    @ApiBody({ type: PlantsDto })
    async createPlant(@Body() req: any): Promise<CommonResponseModel> {
        try {
            return await this.service.createPlant(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }

    }

    @Post('/getActiveAllPlants')
    async getActiveAllPlants(): Promise<CommonResponseModel> {
        try {
            return await this.service.getActiveAllPlants();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }

    @Post('/updatePlant')
    @ApiBody({ type: PlantsDto })
    async updatePlant(@Body() req: any): Promise<CommonResponseModel> {
        try {
            return await this.service.updatePlant(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }

    @Post('/activateOrDeactivatePlant')
    @ApiBody({ type: PlantsDto })
    async activateOrDeactivatePlant(@Body() dto: any, isUpdate: boolean = false): Promise<CommonResponseModel> {
        try {
            return await this.service.activateOrDeactivatePlant(dto);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }

    @Post('/getPlantById')
    @ApiBody({ type: PlantIdReq })
    async getPlantById(@Body() dto: any): Promise<CommonResponseModel> {
        try {
            return await this.service.getPlantById(dto);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }

}